import { WorkSpaceSettings } from "@/core/entities/workspace";
import { IWorkSpaceRepository } from "@/core/repositories/workspace";

export class GetWorkspaceSettingsUseCase {
  constructor(private readonly workspaceRepository: IWorkSpaceRepository) {}

  async execute(): Promise<WorkSpaceSettings | null> {
    return await this.workspaceRepository.getWorkspaceSettings();
  }
}
